module.exports = __webpack_public_path__ + "img/vertical_4_4_3016.9c47086d.png";